import React, { useState, useEffect, useContext } from 'react';
import {
  uploadFile,
  updatekyc,
  updateKycRescreeningDate,
  amlWatcherHits,
  createNotification,
  createKycComment,
  getkycRiskAssessment,
  createKycNestedSanctionComment,
  sendEmailNotification,
  getkyc,
  getkycAll,
  updatekycStatus,
  createkycRiskAssessment,
  updatekycRiskAssessment,
  getAllUsers,
  frontEndBaseURL,
  getKycRecord,
  getCompanyDetails,
} from '../../../../API/Api';
import { Card, checkAPICallsQuota } from '../../../shared/utils';
import KycQuotaModal from '../../../shared/KycQuotaModal';
import QuestionCard_ACRA from '../QuestionCard_ACRA';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import SanctionsScreeningSection from './SanctionsScreeningSection';
import SubmissionCard from '../SubmissionCard';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../../../App';
import QuestionCard_ACRA_Single from '../QuestionCard_ACRA_Single';
import { listG, ListB, highRiskJurisdictions } from '../../../../data/RiskCountries';

const _RiskAssessment_ACRA_AML = ({ clientFormId, userType, readOnly, currentUrl, formAuthority }) => {
  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);

  const [formData, setFormData] = useState({
    kycaml_client_id: clientFormId,
    formAuthority: formAuthority,
    screenedDate: '',
    submittedBy: '',
    reviewerEmail: [],
    sourceOfWealthDocumentURL: '',
    otherDocumentsURL: '',
    managementSupportDocumentURL: '',
    riskLevel: '',
    screenedDate: '',
    nextRescreeningDate: '',
    status: 'new',
    formingOfCorporations: { response: '', comments: [] },
    pepHits: [],
    crimesHits: [],
    sanctionsHits: [],
    highRiskJurisdictionHits: [],
    adverseNewsHits: [],
    screeningSource: 'amlWatcher',
    hasAdverseScreeningResults: 'No',
    hasUnsatisfactoryExceptions: 'No',
    questionApiUrl: {},
  });
  const [kycData, setKycData] = useState();
  const [loading, setLoading] = useState(true);
  const [allreviewers, setAllreviewers] = useState([]);
  const userRole = decodedToken.role;
  let allQuestionsAnswered = true;
  const [mandatoryFieldError, setMandatoryFieldError] = useState({
    riskReasons: '',
    riskLevel: '',
  });
  const [records, setRecords] = useState([]);
  const [editable, setEditable] = useState(true);
  const isApprovalAccepted = formData?.status === 'accepted';
  const effectiveReadOnly = readOnly || isApprovalAccepted;
  const [showQuotaModal, setShowQuotaModal] = useState(false);
  const [apiFailed, setApiFailed] = useState(false);
  const [crimesHitsLoading, setCrimesHitsLoading] = useState(false);

  const getNextRescreeningDateByRiskLevel = riskLevel => {
    if (!riskLevel) return '';
    const currentDate = DateTime.now().setZone('Asia/Singapore');
    const companyId = decodedToken.companyId;
    // Re-assessment frequency: amscorporation, demo-acra (for testing)
    if (companyId == 'amscorporation') {
      if (riskLevel == 'High') return currentDate.plus({ months: 6 }).toFormat('dd-MM-yyyy');
      if (riskLevel == 'Medium') return currentDate.plus({ months: 9 }).toFormat('dd-MM-yyyy');
      if (riskLevel == 'Low') return currentDate.plus({ months: 11 }).toFormat('dd-MM-yyyy');
    } else if (companyId == 'Inspro_Insurance') {
      return currentDate.plus({ years: 1 }).toFormat('dd-MM-yyyy');
    } else {
      if (riskLevel == 'Low') return currentDate.plus({ years: 3 }).toFormat('dd-MM-yyyy');
      if (riskLevel == 'Medium') return currentDate.plus({ years: 2 }).toFormat('dd-MM-yyyy');
      if (riskLevel == 'High') return currentDate.plus({ years: 1 }).toFormat('dd-MM-yyyy');
    }
    return '';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let allreviewers = (await getAllUsers()).data;
        allreviewers = allreviewers.filter(users => users.role !== 'preparer' && users.role !== 'viewer');
        setAllreviewers(allreviewers);

        const currentKycData = await getkyc(clientFormId).then(response => response.data);
        setKycData(currentKycData);

        const kycRiskDataList = await getkycRiskAssessment(clientFormId).then(response => response.data);
        let kycRiskData = kycRiskDataList[0];

        getKycRecordData(currentKycData['_id']);
        if (kycRiskDataList.length !== 0) {
          const status = kycRiskData?.status;
          setEditable(!readOnly && status !== 'accepted');
          const dataToSet = {
            ...kycRiskData,
            nextRescreeningDate:
              kycRiskData.nextRescreeningDate || getNextRescreeningDateByRiskLevel(kycRiskData.riskLevel),
          };
          setFormData(dataToSet);
          checkRiskStatus(dataToSet, currentKycData);
          setLoading(false);
          return;
        }

        setEditable(!readOnly);
        toast.info(`Assessment running...`);
        const emptyFormData = {
          kycaml_client_id: clientFormId,
          riskLevel: '',
          status: 'new',
          pepHits: [],
          crimesHits: [],
          sanctionsHits: [],
          highRiskJurisdictionHits: [],
          adverseNewsHits: [],
          screeningSource: 'amlWatcher',
        };
        const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
        let riskAssessmentId = '';
        kycRiskData = {
          ...emptyFormData,
          screenedDate: creationDate,
        };
        const res = await createkycRiskAssessment(kycRiskData);
        if (res && res.status === 200 && res.data.status) {
          if (!res.data.success) {
            toast.error('Failed to create assessment!');
            setLoading(false);
            return;
          }
          riskAssessmentId = res.data.risk_id;
          kycRiskData = { ...kycRiskData, _id: riskAssessmentId };
        } else {
          toast.error('Failed to create assessment!');
          setLoading(false);
          return;
        }

        const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal, '500-global');
        if (quotaExceeded) {
          setLoading(false);
          return;
        }

        const payload = {
          screenedName: currentKycData['name'],
          connectedParty: currentKycData?.details?.connectedParty,
          entityType: currentKycData['type'],
          kycaml_client_id: currentKycData['_id'],
          screenedDate: creationDate,
          screeningSource: 'amlWatcher',
          nationality: currentKycData?.details?.nationality,
          riskAssessmentId: riskAssessmentId,
        };
        const amlWatcherResponse = await amlWatcherHits(payload);
        if (!amlWatcherResponse.data.success) {
          toast.warning('Data retrieval failed — source may be temporarily unavailable. Please retry later');
          setApiFailed(true);
          setLoading(false);
          return;
        }

        const {
          pepHits,
          crimesHits,
          sanctionsHits,
          highRiskJurisdictionHits,
          adverseNewsHits,
          questionApiUrl,
          riskLevel,
        } = amlWatcherResponse.data;
        const updatedData = {
          ...kycRiskData,
          pepHits,
          crimesHits,
          sanctionsHits,
          highRiskJurisdictionHits,
          adverseNewsHits,
          screeningSource: 'amlWatcher',
          questionApiUrl,
          ...(riskLevel != null && { riskLevel }),
          ...(riskLevel != null && { nextRescreeningDate: getNextRescreeningDateByRiskLevel(riskLevel) }),
        };
        setFormData(updatedData);
        checkRiskStatus(updatedData, currentKycData);
        setApiFailed(false);
        toast.success(`Assessment complete!`);
        setLoading(false);
      } catch (e) {
        console.error(e);
        toast.error(`Something went wrong...`);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (formData?.status === 'accepted') {
      setEditable(false);
    }
  }, [formData?.status]);

  const handleInputChange = e => {
    const { name, type, value, checked } = e.target;

    setFormData(prevFormData => {
      const updatedFormData = {
        ...prevFormData,
        [name]: type === 'checkbox' ? checked : value,
      };
      // allowAutoFill=false so user edits to automated fields are not overwritten
      checkRiskStatus(updatedFormData, kycData, false);
      return updatedFormData;
    });
  };

  const getKycRecordData = async kycaml_client_id => {
    let items = await getKycRecord(kycaml_client_id);
    setRecords(items?.data);
  };
  const handleRunAssessmentAgain = async e => {
    try {
      setLoading(true);
      toast.info(`Assessment running...`);

      const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal, '500-global');
      if (quotaExceeded) {
        setLoading(false);
        return;
      }

      const currentKycData = await getkyc(clientFormId).then(response => response.data);
      setKycData(currentKycData);

      const emptyFormData = {
        kycaml_client_id: clientFormId,
        riskLevel: '',
        status: 'new',
        pepHits: [],
        crimesHits: [],
        sanctionsHits: [],
        highRiskJurisdictionHits: [],
        adverseNewsHits: [],
        screeningSource: 'amlWatcher',
      };
      const currentScreenedDate = formData.screenedDate;
      const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
      const riskAssessmentId = formData._id;
      const kycRiskData = {
        ...emptyFormData,
        screenedDate: creationDate,
        currentScreenedDate,
        _id: riskAssessmentId,
      };

      const res = await updatekycRiskAssessment(kycRiskData);
      if (res && res.status === 200 && res.data.status) {
        if (!res.data.success) {
          toast.error('Failed to update assessment!');
          setLoading(false);
          return;
        }
      } else {
        toast.error('Failed to update assessment!');
        setLoading(false);
        return;
      }

      const payload = {
        screenedName: currentKycData['name'],
        connectedParty: currentKycData?.details?.connectedParty,
        entityType: currentKycData['type'],
        kycaml_client_id: currentKycData['_id'],
        screenedDate: creationDate,
        screeningSource: 'amlWatcher',
        nationality: currentKycData?.details?.nationality,
        riskAssessmentId: riskAssessmentId,
      };
      const amlWatcherHitsResponse = await amlWatcherHits(payload);
      if (!amlWatcherHitsResponse.data.success) {
        toast.warning('Data retrieval failed — source may be temporarily unavailable. Please retry later');
        setApiFailed(true);
        setLoading(false);
        return;
      }

      const {
        pepHits,
        crimesHits,
        sanctionsHits,
        highRiskJurisdictionHits,
        adverseNewsHits,
        questionApiUrl,
        riskLevel,
      } = amlWatcherHitsResponse.data;
      const updatedData = {
        ...kycRiskData,
        pepHits,
        crimesHits,
        sanctionsHits,
        highRiskJurisdictionHits,
        adverseNewsHits,
        screeningSource: 'amlWatcher',
        questionApiUrl,
        ...(riskLevel != null && { riskLevel }),
        ...(riskLevel != null && { nextRescreeningDate: getNextRescreeningDateByRiskLevel(riskLevel) }),
      };
      setFormData({
        ...updatedData,
        hasAdverseScreeningResults: 'No',
        hasUnsatisfactoryExceptions: 'No',
      });
      checkRiskStatus(updatedData, currentKycData);
      setApiFailed(false);
      toast.success(`Assessment complete!`);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
      toast.error(`Something went wrong...`);
    }
  };

  const handleSaveForm = async e => {
    const res = await updatekycRiskAssessment(formData);
    if (res && res.status === 200 && res.data.status) {
      if (res.data.success) {
        toast.success('Assessment saved!');
      } else {
        toast.warning('Assessment already saved!');
      }
    } else {
      toast.error('Failed to save assessment!');
    }
  };

  const handleSubmitForReview = async e => {
    let newFormData = {
      ...formData,
      status: 'waiting for review',
      submitPerson: decodedToken.name,
      submitDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
    };

    const res = await updatekycRiskAssessment(newFormData);
    if (res && res.status === 200 && res.data.status) {
      if (res.data.success) {
        const res2 = await updatekycStatus({ formStatus: 'pending_reviewer_review', id: clientFormId });
        if (res2 && res2.status === 200 && res2.data.success) {
          toast.success('Assessment submitted!');
        } else {
          toast.error('Failed to submit assessment!');
          return;
        }
      } else {
        toast.warning('Assessment already submitted!');
      }
    } else {
      toast.error('Failed to submit assessment!');
      return;
    }

    sendEmailNotification({
      email: formData.reviewerReviewEmail?.includes('/')
        ? formData.reviewerReviewEmail.split('/')[0]
        : formData.reviewerReviewEmail,
      subject: 'KYC Risk Assessment Form pending review - iCompass',
      message: `
        <div style="max-width: 600px; margin: 0 auto; border: 2px solid #FF8C00; padding: 20px; text-align: center;">
          <h1 style="margin-bottom: 20px; text-decoration: underline;"> Risk Assessment Approval Pending</h1>
          <p>${decodedToken.name} has submitted a risk assessment form, ${kycData.name} (${kycData.type}), for your approval.
            <a href='${window.location.href}'> Click to view form </a>
          </p>
          <img src="https://icompass-backend-dev-fhagh5hccpf2ebh9.southeastasia-01.azurewebsites.net/images/from_icompass" alt="iCOMPASS logo" style="display: block; margin: 20px auto; width: 200px; height: auto; max-width: 100%;">
          <p style="font-style: italic; margin-top: 20px;">Please do not reply to this email</p>
        </div> `,
    });

    setFormData(newFormData);

    createNotification({
      type: 'KYC',
      text: `${kycData.name} status has changed to Pending reviewer Review`,
      date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
    });
  };

  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    const { name } = e.target;
    if (!file) {
      return;
    }

    try {
      const data = new FormData();
      data.append('file', file);
      const filename = `${file.name}`;
      const res = await uploadFile(data, filename);

      if (res) {
        setFormData(prevState => ({
          ...prevState,
          [name]: res.data.url,
        }));
      } else {
        toast.error('Invalid file type!');
      }
    } catch (e) {
      toast.error(`Invalid file type!`);
    }
  };

  const checkRiskStatus = (newFormData, kycDataOverride, allowAutoFill = true) => {
    const kyc = kycDataOverride ?? kycData;
    if (allowAutoFill) {
      if (userType === 'individual' && kyc?.details) {
        const d = kyc.details;
        const isPep = [d.pepPerson, d.pepAssociate, d.pepFamily].some(v => String(v || '').toLowerCase() === 'yes');
        newFormData.politicallyExposedPerson = isPep ? 'Yes' : 'No';
      }

      const listGUpper = listG.map(c => String(c).toUpperCase());
      const listBUpper = (ListB || []).map(c => String(c).toUpperCase());
      const highRiskUpper = (highRiskJurisdictions || []).map(c => String(c).toUpperCase());
      if (kyc?.details) {
        if (userType === 'individual') {
          const res = (kyc.details.residenceCountry || '').toUpperCase();
          const nat = (kyc.details.nationality || '').toUpperCase();
          newFormData.connectedToSanctionedCountry =
            listGUpper.includes(res) || listGUpper.includes(nat) ? 'Yes' : 'No';
          const inListB = listBUpper.includes(res) || listBUpper.includes(nat);
          newFormData.connectedToTerroristFundingCountry = inListB ? 'Yes' : 'No';
          newFormData.connectedToFATFCountry = inListB ? 'Yes' : 'No';
          const inHighRisk = highRiskUpper.includes(res) || highRiskUpper.includes(nat);
          newFormData.connectedToHighFATFGreyCountry = inHighRisk ? 'Yes' : 'No';
        } else if (userType === 'entity') {
          const inc = (kyc.details.incorporationCountry || '').toUpperCase();
          newFormData.connectedToSanctionedCountry = listGUpper.includes(inc) ? 'Yes' : 'No';
          const inListB = listBUpper.includes(inc);
          newFormData.connectedToTerroristFundingCountry = inListB ? 'Yes' : 'No';
          newFormData.connectedToFATFCountry = inListB ? 'Yes' : 'No';
          newFormData.connectedToHighFATFGreyCountry = highRiskUpper.includes(inc) ? 'Yes' : 'No';
        }
      }
    }

    const SectionA_Questions = [
      'formingOfCorporations',
      'actingAsDirectorSecretaryPartner',
      'actingAsShareholder',
      'providingRegisteredOffice',
      'buyingSellingRealEstate',
      'managingClientAssets',
      'managingBankAccounts',
      'organizingCompanyContributions',
      'buyingSellingBusinessEntities',
      'statutoryAuditServices',
      'providingOtherServices',
    ];
    let SectionA_yes_count = 0;

    SectionA_Questions.forEach(SectionA_qn_key => {
      if (newFormData[SectionA_qn_key] == true) {
        SectionA_yes_count++;
      }
    });

    const SectionB_Questions = [
      'newClient',
      'cashIntensiveBusiness',
      'frequentUnaccountedCashTransactions',
      'politicallyExposedPerson',
      'outdatedCompanyAccounts',
      'problemObtainingInfo',
      'infoNotIndependentlyVerified',
      'highRiskIndustry',
      'isPublicCompanyNoDisclosure',
      'isLegalPersonOrEntity',
      'usesNomineeDirectorsShareholders',
      'nomineeShareholdersMajorityOwnership',
      'unusualComplexOwnershipStructure',
      'directorsCriminalConvictions',
      'frequentDirectorChanges',
      'unregisteredNonProfitOrganisation',
      'shellCompany',
      'hasAdverseScreeningResults',
      'hasUnsatisfactoryExceptions',
    ];
    let SectionB_yes_count = 0;

    SectionB_Questions.forEach(SectionB_qn_key => {
      const val = newFormData[SectionB_qn_key];
      const isYes = val?.response == 'Yes' || val == 'Yes';
      const isNo = val?.response == 'No' || val == 'No';
      // "Can the information be verified by independent sources?" — Yes = no risk, No = risk (inverted vs other Section B questions)
      if (SectionB_qn_key === 'infoNotIndependentlyVerified') {
        if (isNo) SectionB_yes_count++;
      } else if (isYes) {
        SectionB_yes_count++;
      }
    });

    const EDD_Hits_Questions = [
      'pepHits',
      'crimesHits',
      'sanctionsHits',
      'highRiskJurisdictionHits',
      'adverseNewsHits',
    ];
    if (allowAutoFill) {
      newFormData.hasAdverseScreeningResults = 'No';
      EDD_Hits_Questions.forEach(EDD_qn_justification_key => {
        (newFormData[EDD_qn_justification_key] || []).forEach(hit => {
          if (hit?.response === 'Yes' && hit?.justification.trim() == '') {
            SectionB_yes_count++;
          } else if (hit?.response === 'Yes' && hit?.justification.trim() !== '') {
            SectionB_yes_count++;
          }
        });
      });
      if ((newFormData.adverseNewsHits || []).length > 0) {
        newFormData.hasAdverseScreeningResults = 'Yes';
      }
      // hasUnsatisfactoryExceptions: no auto-fill, user answers manually
    } else {
      EDD_Hits_Questions.forEach(EDD_qn_justification_key => {
        (newFormData[EDD_qn_justification_key] || []).forEach(hit => {
          if (hit?.response === 'Yes') {
            SectionB_yes_count++;
          }
        });
      });
    }

    const SectionC_Questions = [
      'connectedToHighRiskAmlCountry',
      'connectedToHighRiskJurisdiction',
      'connectedToSanctionedCountry',
      'connectedToTerroristFundingCountry',
      'connectedToFATFCountry',
    ];
    let SectionC_yes_count = 0;

    SectionC_Questions.forEach(SectionC_qn_key => {
      if (newFormData[SectionC_qn_key] == 'Yes') {
        SectionC_yes_count++;
      }
    });

    const SectionD_Questions = [
      'anonymousTransactionInstructions',
      'fundsTransferWithoutUnderlyingService',
      'unusualTransactionPatterns',
      'unaccountedPaymentsFromUnknownParties',
      'instructionForShellCompanyWithNominees',
      'purchaseOfEntitiesWithoutCommercialPurpose',
      'relationshipWithoutPhysicalMeeting',
      'transactionsWithoutPhysicalMeeting',
      'inconsistentWithClientRiskProfile',
      'notPhysicallyPresentForIncorporation',
      'notPhysicallyPresentForShelfCompanyTransfer',
    ];
    let SectionD_yes_count = 0;

    SectionD_Questions.forEach(SectionD_qn_key => {
      if (newFormData[SectionD_qn_key] == 'Yes') {
        SectionD_yes_count++;
      }
    });

    // Section B: 5 or more Yes -> High risk level; 4 or less Yes -> maintain Medium (same for individual and entity)
    // Section D: 5 or more Yes -> High risk level; 4 or less Yes -> maintain Medium
    let riskLevel = '';

    if (
      (SectionB_yes_count > 4 && userType == 'individual') ||
      (SectionB_yes_count > 9 && userType == 'entity') ||
      SectionC_yes_count > 0 ||
      SectionD_yes_count > 4
    ) {
      riskLevel = 'High';
    } else {
      riskLevel = 'Medium';
    }
    const updatedFormData = {
      ...newFormData,
      riskLevel: riskLevel,
      nextRescreeningDate: getNextRescreeningDateByRiskLevel(riskLevel),
    };

    setFormData(updatedFormData);
  };

  const getRiskTag = risk => {
    const riskClasses = {
      Low: 'text-green-500',
      Medium: 'text-orange-500',
      High: 'text-red-500',
      Edge: 'text-purple-600',
    };
    const riskClass = riskClasses[risk] || riskClasses['Edge'];
    return <span className={`bg-gray-200 py-2 px-4 border border-b-gray-300 ${riskClass}`}>{risk}</span>;
  };

  const getStatusTag = status => {
    if (status == 'new' || status == 'waiting for review') {
      return <span className='text-orange-500'> Yet to be decided by reviewer</span>;
    } else if (status == 'accepted') {
      return <span className='text-green-500'>Accepted</span>;
    } else if (status == 'rejected') {
      return <span className='text-red-500'>Rejected</span>;
    } else {
      return <span className='text-purple-600'>Edge case!!!</span>;
    }
  };

  const handleStatusUpdate = async (e, updatedStatus) => {
    const quotaExceeded = await checkAPICallsQuota(setShowQuotaModal);
    if (quotaExceeded) return;
    let nextRescreeningDate = '';
    let onGoingMonitoring = '';
    let maxPage = 2;

    if (updatedStatus == 'accepted') {
      const effectiveRiskLevel =
        formData.overrideRiskSelected === 'true' && formData.overrideRiskLevel
          ? formData.overrideRiskLevel
          : formData.riskLevel;
      nextRescreeningDate = getNextRescreeningDateByRiskLevel(effectiveRiskLevel);
      onGoingMonitoring = true;
      maxPage = 3;
      formData.reviewStatus = 'Pending Assessment';
    }

    const currentScreenedDate = formData.screenedDate;
    formData.createDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
    const newFormData = {
      ...formData,
      status: updatedStatus,
      screenedDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
      nextRescreeningDate: nextRescreeningDate,
      approvalPerson: decodedToken.name,
      approvalDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
      currentScreenedDate,
    };

    setFormData(newFormData);
    try {
      await updatekycStatus({
        reviewStatus: 'Pending Assessment',
        formStatus: updatedStatus,
        id: clientFormId,
        nextRescreeningDate: nextRescreeningDate,
        onGoingMonitoring: onGoingMonitoring,
        maxPage: maxPage,
        createDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
      });
    } catch (err) {
      toast.error('Failed to update status');
      return;
    }

    const res = await updatekycRiskAssessment(newFormData);
    if (res && res.status === 200 && res.data.status) {
      if (!res.data.success) {
        toast.error('Failed to update assessment!');
        return;
      }
    } else {
      toast.error('Failed to update assessment!');
      return;
    }

    createNotification({
      type: 'KYC',
      text: `${kycData.name} status has changed to ${updatedStatus}`,
      date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
    });
  };

  let qnCounterA = 1;
  let qnCounterB = 1;
  let qnCounterC = 1;
  let qnCounterD = 1;
  let qnCounterE = 1;
  return (
    <div
      className={`max-w-6xl mx-auto mt-3 p-5 rounded-lg shadow-lg ${effectiveReadOnly ? 'bg-gray-200' : 'bg-white '}`}
    >
      {loading ? (
        <div className='h-screen w-screen'> Loading... </div>
      ) : (
        <div>
          <div className='flex justify-between'>
            <h1 className='font-semibold underline text-2xl m-2 mb-4'>KYC Form - Risk Assessment (ACRA) </h1>
            <button
              onClick={handleRunAssessmentAgain}
              disabled={effectiveReadOnly}
              className={`self-center w-2/12 py-1 px-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg ${effectiveReadOnly ? 'opacity-30' : 'opacity-100'}`}
            >
              Run Assessment again
            </button>
          </div>

          <div className='border p-2'>
            <h2 className='font-semibold underline text-l m-2 mb-4'>
              Section A (Nature of Services Required by Customer/Client)
            </h2>
            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'formingOfCorporations'}
              handleInputChange={handleInputChange}
              question={'Forming, on behalf of another person, a corporation or other legal person?'}
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.formingOfCorporations}
            />

            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'actingAsDirectorSecretaryPartner'}
              handleInputChange={handleInputChange}
              question={
                'Acting, or arranging for another person to act –  (i) as a director or secretary of a corporation;  (ii) as a partner of a partnership; or  (iii) in a similar capacity in relation to other legal persons ?'
              }
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.actingAsDirectorSecretaryPartner}
            />

            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'actingAsShareholder'}
              handleInputChange={handleInputChange}
              question={
                'Acting, or arranging for another person to act, as a nominee shareholder on behalf of any corporation, other than a corporation whose securities are listed on an approved exchange within the meaning of section 2(1) of the Securities and Futures Act 2001 ?'
              }
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.actingAsShareholder}
            />

            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'providingRegisteredOffice'}
              handleInputChange={handleInputChange}
              question={
                'Providing a registered office, business address, correspondence or administrative address or other related services for a corporation, partnership or other legal person?'
              }
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.providingRegisteredOffice}
            />

            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'buyingSellingRealEstate'}
              handleInputChange={handleInputChange}
              question={'Carrying out any designated activity in relation to the provision of any accounting service?'}
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.buyingSellingRealEstate}
            />

            <QuestionCard_ACRA_Single
              disabled={effectiveReadOnly}
              checkbox={true}
              inputName={'managingClientAssets'}
              handleInputChange={handleInputChange}
              question={
                'Carrying out an ACRA transaction with the ACRA Registrar using the electronic transaction system – (i) on behalf of another person; or (ii) for one or more companies as a secretary of each of those companies?'
              }
              questionNumber={qnCounterA++}
              justification={false}
              value={formData?.managingClientAssets}
            />
          </div>

          <>
            <h2 className='font-semibold underline text-l m-2 mb-4'>Section B - Risk Assessment of Customer/Client</h2>
            {/* Section B, Q1-18 */}
            {/* Q1 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'newClient'}
              handleInputChange={handleInputChange}
              question={'Is this a new customer/client? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.newClient}
            />

            {/* Q2 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'cashIntensiveBusiness'}
              handleInputChange={handleInputChange}
              question={"Is the customer/client's business cash-intensive? "}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.cashIntensiveBusiness}
            />

            {/* Q3 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'frequentUnaccountedCashTransactions'}
              handleInputChange={handleInputChange}
              question={
                'Does the customer/client frequently make unaccounted cash transactions to similar recipient(s)? '
              }
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.frequentUnaccountedCashTransactions}
            />

            {/* Q4 - auto-filled from step 1: pepPerson / pepAssociate / pepFamily (any Yes -> Yes) */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'politicallyExposedPerson'}
              handleInputChange={handleInputChange}
              question={'Is any of the customer/client, beneficial owner or its agent a politically exposed person? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.politicallyExposedPerson}
              automated={true}
            />

            {/* Q5 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'outdatedCompanyAccounts'}
              handleInputChange={handleInputChange}
              question={'Are the customer/clients’s company financial statements outdated? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.outdatedCompanyAccounts}
            />

            {/* Q6 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'problemObtainingInfo'}
              handleInputChange={handleInputChange}
              question={'Is there any problem obtaining the required information in the relevant form? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.problemObtainingInfo}
            />

            {/* Q7 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'infoNotIndependentlyVerified'}
              handleInputChange={handleInputChange}
              question={'Can the information obtained be verified by independent and reliable sources? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.infoNotIndependentlyVerified}
            />

            {/* Q8 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'highRiskIndustry'}
              handleInputChange={handleInputChange}
              question={'Is the customer/client in a high-risk industry? '}
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.highRiskIndustry}
            />

            {userType == 'entity' && (
              <>
                {/* Q9 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'isPublicCompanyNoDisclosure'}
                  handleInputChange={handleInputChange}
                  question={
                    'Is the customer/client a public company listed on any stock exchange and exempted from disclosure requirements?  '
                  }
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.isPublicCompanyNoDisclosure}
                />

                {/* Q11 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'usesNomineeDirectorsShareholders'}
                  handleInputChange={handleInputChange}
                  question={'Does the customer/client use nominee director(s) or shareholder(s)? '}
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.usesNomineeDirectorsShareholders}
                />
                {/* Q12 */}

                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'nomineeShareholdersMajorityOwnership'}
                  handleInputChange={handleInputChange}
                  question={'Where applicable, do the nominee shareholders represent majority ownership? '}
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.nomineeShareholdersMajorityOwnership}
                />

                {/* Q13 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'unusualComplexOwnershipStructure'}
                  handleInputChange={handleInputChange}
                  question={
                    'Does the ownership structure of the customer/client appear unusual or excessively complex given the nature of its business? '
                  }
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.unusualComplexOwnershipStructure}
                />

                {/* Q14 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'directorsCriminalConvictions'}
                  handleInputChange={handleInputChange}
                  question={
                    'Do the proposed directors/partners/shareholders have prior criminal convictions involving fraud or dishonesty? '
                  }
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.directorsCriminalConvictions}
                />

                {/* Q15 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'frequentDirectorChanges'}
                  handleInputChange={handleInputChange}
                  question={
                    "Do the customer/client's shareholders and/or directors frequently change, and the changes are within reason? "
                  }
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.frequentDirectorChanges}
                />

                {/* Q16 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'unregisteredNonProfitOrganisation'}
                  handleInputChange={handleInputChange}
                  question={
                    'Is the customer/client a charitable or non-profit organisation that is not registered in Singapore? '
                  }
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.unregisteredNonProfitOrganisation}
                />

                {/* Q17 */}
                <QuestionCard_ACRA
                  disabled={effectiveReadOnly}
                  inputName={'shellCompany'}
                  handleInputChange={handleInputChange}
                  question={'Does the customer/client appear to be a shell company? '}
                  questionNumber={qnCounterB++}
                  justification={false}
                  value={formData?.shellCompany}
                />
              </>
            )}

            {/* Q9  entity Q18*/}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'hasAdverseScreeningResults'}
              handleInputChange={handleInputChange}
              question={
                'The registered CSP has performed screening of particulars of the customer/client, beneficial owners of the customer/client, persons acting on behalf of the customer/client, and connected parties of the customer/client against the required information sources, for example, Alert list provided by ACRA, on Google, the sanctions lists published by the Office of Foreign Assets Control of the US Department of the Treasury , against the regulations under the United Nations Act 2001; First Schedule of the Terrorism (Suppression of Financing) Act 2002; and/or other third party screening database. Are there adverse news or information arising? '
              }
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.hasAdverseScreeningResults}
              automated={true}
            />

            {/* Q10 entity Q19 - no auto-fill, user answers manually */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'hasUnsatisfactoryExceptions'}
              handleInputChange={handleInputChange}
              question={
                'Exceptions noted, from details of the customer/client, beneficial owner of the customer/client, person acting on behalf of the customer/client, or connected party of the customer/client, cannot be disposed of satisfactorily. '
              }
              questionNumber={qnCounterB++}
              justification={false}
              value={formData?.hasUnsatisfactoryExceptions}
            />

            <SanctionsScreeningSection
              userId={clientFormId}
              qnCounter={qnCounterB}
              readOnly={effectiveReadOnly}
              formData={formData}
              kycData={kycData}
              setFormData={setFormData}
              checkRiskStatus={checkRiskStatus}
              decodedToken={decodedToken}
              crimesHitsLoading={crimesHitsLoading}
              apiFailed={apiFailed}
            />
          </>

          <>
            <h2 className='font-semibold underline text-l m-2 mb-4'>Section C</h2>

            {/* Auto-filled from step 1: residence/nationality (individual) or incorporation country (entity) in listG */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'connectedToSanctionedCountry'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer/client connected to or transacting with a country or a territory that is sanctioned by a regulatory body, such as the United Nations (UN)? '
              }
              questionNumber={qnCounterC++}
              justification={false}
              value={formData?.connectedToSanctionedCountry}
              automated={true}
            />

            {/* Auto-filled from step 1: residence/nationality (individual) or incorporation country (entity) in listB */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'connectedToTerroristFundingCountry'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer/client connected to or transacting with a country or a territory that is identified to be funding or supporting terrorist activities or that have designated terrorist organisations operating within their territories? '
              }
              questionNumber={qnCounterC++}
              justification={false}
              value={formData?.connectedToTerroristFundingCountry}
              automated={true}
            />

            {/* Auto-filled from step 1: residence/nationality (individual) or incorporation country (entity) in listB */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'connectedToFATFCountry'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer/client connected to or transacting with a country or a territory in relation to which the FATF has called for countermeasures? '
              }
              questionNumber={qnCounterC++}
              justification={false}
              value={formData?.connectedToFATFCountry}
              automated={true}
            />
            {/* Auto-filled from step 1: residence/nationality (individual) or incorporation country (entity) in highRiskJurisdictions */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'connectedToHighFATFGreyCountry'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer connected to or transacting with a country or territory in relation to which the FATF has subject to increased monitoring?  '
              }
              questionNumber={qnCounterC++}
              justification={false}
              value={formData?.connectedToHighFATFGreyCountry}
              automated={true}
            />
          </>

          <>
            <h2 className='font-semibold underline text-l m-2 mb-4'>Section D</h2>
            {/* Q1 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'anonymousTransactionInstructions'}
              handleInputChange={handleInputChange}
              question={
                'Has the customer/client given any instruction to perform a transaction (which may include cash) anonymously? '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.anonymousTransactionInstructions}
            />

            {/* Q2 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'fundsTransferWithoutUnderlyingService'}
              handleInputChange={handleInputChange}
              question={
                'Has the customer transferred any funds without providing underlying services or transactions?  '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.fundsTransferWithoutUnderlyingService}
            />

            {/* Q3 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'unusualTransactionPatterns'}
              handleInputChange={handleInputChange}
              question={
                'Are there unusual patterns of transactions that have no apparent economic purpose or large cash payments, in which disbursement would have been normally made by other modes of payment (such as cheque, bank drafts etc.)? '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.unusualTransactionPatterns}
            />

            {/* Q4 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'unaccountedPaymentsFromUnknownParties'}
              handleInputChange={handleInputChange}
              question={
                'Are there unaccounted payments received from unknown or un-associated third parties for services and/or transactions provided by the customer/client? '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.unaccountedPaymentsFromUnknownParties}
            />

            {/* Q5 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'instructionForShellCompanyWithNominees'}
              handleInputChange={handleInputChange}
              question={
                'Is there instruction from the customer/client to incorporate shell companies with nominee shareholder(s) and/or director(s)? '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.instructionForShellCompanyWithNominees}
            />

            {/* Q6 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'purchaseOfEntitiesWithoutCommercialPurpose'}
              handleInputChange={handleInputChange}
              question={
                'Does the customer/client intend to purchase companies or business entities with no apparent commercial purpose? This would include:  a) Multi-layer, multi-country and complex group structures.  b) Setting up entities in Singapore where there is no obvious commercial purpose, or any other personal or economic connection to the customer. '
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.purchaseOfEntitiesWithoutCommercialPurpose}
            />

            {/* Q7 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'relationshipWithoutPhysicalMeeting'}
              handleInputChange={handleInputChange}
              question={'Is this business relationship being established without any physical meeting? '}
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.relationshipWithoutPhysicalMeeting}
            />

            {/* Q8 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'transactionsWithoutPhysicalMeeting'}
              handleInputChange={handleInputChange}
              question={'Are there any transactions being performed without any physical meeting? '}
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.transactionsWithoutPhysicalMeeting}
            />

            {/* Q9 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'inconsistentWithClientRiskProfile'}
              handleInputChange={handleInputChange}
              question={
                "Are the transactions required by the customer/client inconsistent with the professional intermediaries' knowledge on the customer/client's risk profile and nature of business?"
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.inconsistentWithClientRiskProfile}
            />

            {/* Q10 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'notPhysicallyPresentForIncorporation'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer not physically present for identification purposes in a proposed incorporation transaction?'
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.notPhysicallyPresentForIncorporation}
            />

            {/* Q11 */}
            <QuestionCard_ACRA
              disabled={effectiveReadOnly}
              inputName={'notPhysicallyPresentForShelfCompanyTransfer'}
              handleInputChange={handleInputChange}
              question={
                'Is the customer not physically present for identification purposes in a proposed transaction involving the transfer of management or ownership or sale of a shelf company?'
              }
              questionNumber={qnCounterD++}
              justification={false}
              value={formData?.notPhysicallyPresentForShelfCompanyTransfer}
            />
          </>

          <Card>
            <p className='mb-2 font-semibold'> Outcome </p> <hr />
            <p className='my-4'> The risk level is determined to be: {getRiskTag(formData?.riskLevel)} </p>
            <SubmissionCard
              getRiskTag={getRiskTag}
              formData={{
                ...formData,
                nextRescreeningDate:
                  formData.overrideRiskSelected === 'true' && formData.overrideRiskLevel
                    ? getNextRescreeningDateByRiskLevel(formData.overrideRiskLevel)
                    : formData.nextRescreeningDate || getNextRescreeningDateByRiskLevel(formData.riskLevel),
              }}
              setFormData={setFormData}
              handleFileChange={handleFileChange}
              getStatusTag={getStatusTag}
              handleStatusUpdate={handleStatusUpdate}
              handleSaveForm={handleSaveForm}
              handleInputChange={handleInputChange}
              currentUrl={currentUrl}
              userRole={userRole}
              allreviewers={allreviewers}
              handleSubmitForReview={handleSubmitForReview}
              clientFormId={clientFormId}
              readOnly={effectiveReadOnly}
              formAuthority={formAuthority}
            />
          </Card>
        </div>
      )}
      <KycQuotaModal
        status={showQuotaModal}
        onClose={() => setShowQuotaModal(false)}
      />
    </div>
  );
};

export default _RiskAssessment_ACRA_AML;
